import angular from 'angular';
import { IContribuinteIndividual } from '../model/contribuintesindividuais.model';
import { ISolicitacao } from '../../Solicitacoes/models/solicitacao.model';
import { Usuario } from '../../../../core/usuario/models/usuario-model';
import { MeurhContribuintesIndividuaisService } from '../contribuintesindividuais.service';
import { MeurhSolicitacoes } from '../../Solicitacoes/services/solicitacoes.service';
import { ModalConfirmService } from '../../../../shared/components/modal-confirm/modal.confirm.service';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../utils/nsj-table';

type IContribuintesIndividuaisFilters = {
    lotacao?: { lotacao: string; } | null;
	situacao: string | null;
    busca: string | null;
};

export class MeurhContribuintesIndividuaisIndexController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        'MeurhContribuintesIndividuaisService',
        'MeurhSolicitacoes',
        'ModalConfirmService',
        'NewToaster',
    ];

    public busy = false;
    public loading = false;
    public filters: IContribuintesIndividuaisFilters = {
        situacao: '0',
        busca: null,
    };
    public entities: IContribuinteIndividual[] = [];

    public fields = applyNsjTableInlineMobileLabels([
            {
                value: 'created_at',
                label: 'Data de criação',
                type: 'date',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    let someHtmlVar = `
                    <span ng-bind="tableRowEntity.created_at | asDate | date: 'dd/MM/yyyy'"></span> às <span ng-bind="tableRowEntity.created_at | asDateTime | date: 'HH:mm'"></span>
                  `;
                    return someHtmlVar;
                },
            }, /* {
                value: 'subtipo',
                label: 'Tipo de contribuinte',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <span ng-if="tableRowEntity.subtipo === 0">Autônomo</span>
                        <span ng-if="tableRowEntity.subtipo === 1">Diretor</span>
                        <span ng-if="tableRowEntity.subtipo === 2">Cooperado</span>
                    `;
                    return someHtmlVar;
                },
            }, */ {
                value: 'nome',
                label: 'Nome',
                type: 'string',
                style: 'title',
                copy: '',
            }, {
                value: 'cpf',
                label: 'CPF',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    let someHtmlVar = `
                    <span>{{tableRowEntity.cpf | mask: "999.999.999-99"}}</span>
                  `;
                    return someHtmlVar;
                },
            }, {
                value: 'datainicioprestacao',
                label: 'Data de início',
                type: 'date',
                style: 'title',
                copy: '',
            }, {
                value: 'situacao',
                label: 'Situação',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <label
                            ng-if="!tableRowEntity.wkf_estado"
                            class="label {{tableRowEntity.situacao | situacaoSolicitacaoClassEnum}}"
                        >
                            {{tableRowEntity.situacao | situacaoSolicitacaoEnum}}
                        </label>
                        <label
                            ng-if="tableRowEntity.wkf_estado"
                            class="label {{tableRowEntity.situacao | situacaoSolicitacaoClassEnum}}"
                        >
                            {{ tableRowEntity.wkf_estado }}
                        </label>
                    `;
                  return someHtmlVar;
                },
            }, {
                value: 'solicitacao',
                label: 'Ações',
                type: 'div',
                style: 'title',
                copy: '',
                customLabelHtml: buildNsjTableInlineMobileLabel('Ações', { showOnMobile: false }),
                customCollumnScope: {
                    visualizarSolicitacao: (entity: IContribuinteIndividual) => {
                        this.busy = true;
                        this.$state.go('meurh_contribuintesindividuais_show', {
                            solicitacao: entity.solicitacao
                        });
                    },
                    cancelarSolicitacao: (entity: IContribuinteIndividual & ISolicitacao) => {
                        this.modalCancelar(entity);
                    },
                },
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <div class="display-flex justify-content-center justify-content-end-md">
                            <nsj-button-dropdown
                                border="none"
                                split="false"
                                size="sm"
                                icon="fas fa-ellipsis-v"
                                dropdown-direction="right"
                                class="menuEllipsis"
                                ng-if="tableRowEntity.situacao === 0 &&
                                    (tableRowEntity.created_by.email === '${this.$rootScope.usuario.email}')"
                            >
                                <item-dropdown
                                    item-label="Visualizar"
                                    ng-click="customCollumnScope.visualizarSolicitacao(tableRowEntity)"
                                ></item-dropdown>
                                <item-dropdown
                                    item-label="Cancelar cadastro"
                                    ng-click="customCollumnScope.cancelarSolicitacao(tableRowEntity)"
                                ></item-dropdown>
                            </nsj-button-dropdown>
                            <a
                                class="btn btn-tertiary btn-sm"
                                ng-click="customCollumnScope.visualizarSolicitacao(tableRowEntity)"
                                ng-if="!(tableRowEntity.situacao === 0 &&
                                    (tableRowEntity.created_by.email === '${this.$rootScope.usuario.email}'))"
                            >
                                Visualizar
                            </a>
                        </div>
                    `;
                  return someHtmlVar;
                },
            }
    ]);

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean,
            usuario: Usuario,
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public MeurhContribuintesIndividuaisService: MeurhContribuintesIndividuaisService,
        public MeurhSolicitacoes: MeurhSolicitacoes,
        public ModalConfirmService: ModalConfirmService,
        public NewToaster: { pop: Function },
    ) {
        if (
            !this.$rootScope.temPermissao('visualizar_contribuinte') ||
            !$rootScope.liberadoTela('LIBERAR_SOLICITACAO_CONTRATACAO_CONTRIBUINTE')
        ) {
            $state.go('dp');
        }

        this.loadEntities();

        $scope.$on('meurh_solicitacoescontratacaocontribuinte_index_loaded', (event, args: IContribuinteIndividual[]) => {
            this.entities = args;
        });
    }

    loadEntities() {
        const constructor = {};

        if (!this.valorExiste(this.filters.lotacao)) {
			this.filters.lotacao = null;
        } else {
            constructor['lotacao'] = this.filters.lotacao?.lotacao;
        }

		if (!this.valorExiste(this.filters.situacao)) {
			this.filters.situacao = null;
        } else {
            constructor['situacao'] = this.filters.situacao;
        }

        if (!this.valorExiste(this.filters.busca)) {
			this.filters.busca = null;
        } else {
            constructor['filter'] = this.filters.busca;
        }

        this.entities = [];
        this.MeurhContribuintesIndividuaisService.getContratacoesContribuinte(constructor);
    }

    modalCancelar(entity: IContribuinteIndividual & ISolicitacao) {
        const customText = {
            title: 'Cancelar cadastro',
            subtitle: 'Você está prestes a cancelar o cadastro de autônomo de',
            confirmText: 'Após o cancelamento, não será possível desfazer. Deseja continuar?',
            confirmTextNum: entity.nome,
            closeButton: 'Voltar',
            confirmButton: 'Cancelar cadastro',
        };
        const confirm = this.ModalConfirmService.openCancelar(
            entity,
            'Solicitação de inclusão de autônomo',
            customText
        );
        confirm.result.then((entity: IContribuinteIndividual & ISolicitacao) => {
            this.cancelar(entity);
        }).catch(() => {/**/});
    }

    cancelar(entity: IContribuinteIndividual & ISolicitacao) {
        this.busy = true;
        this.MeurhSolicitacoes.cancelar(entity).then(() => {
            this.NewToaster.pop({
                type: 'success',
                title: 'A Solicitação de inclusão de autônomo foi cancelada com sucesso.'
            });
            this.loadEntities();
        }).catch((response: any) => {
            let error = 'Ocorreu um erro ao cancelar a solicitação de inclusão de autônomo.';
            if (response.data?.message) {
                error = response.data.message;
            }
            this.NewToaster.pop({
                type: 'error',
                title: error
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    private valorExiste(valor: any) {
		return valor !== '' && valor !== undefined && valor !== null ? true : false;
	}
}
